// CompTIA Security+ (SY0-701) hub configuration
import flashcards from './flashcards.js';
import practice from './practice.js';
import objective from './objective.js';

const config = {
  slug: 'comptia-secplus',
  vendor: 'CompTIA',
  vendorTag: 'CompTIA · Cybersecurity Operations',
  title: 'SECURITY',
  titleAccent: '+',
  fullTitle: 'Security+',
  code: 'SY0-701',
  channelTag: 'SECPLUS',
  threatPill: '● TARGET: SY0-701',
  themeStorageKey: 'secplus.theme',
  storagePrefix: 'secplus',
  passPct: 80,
  practice: { totalSeconds: 90 * 60, passPct: 80 },
  objective: { totalSeconds: 30 * 60, passPct: 80 },
  domainNames: {
    D1: 'General Concepts',
    D2: 'Threats & Mitigations',
    D3: 'Architecture',
    D4: 'Operations',
    D5: 'Program Management',
  },
  data: { flashcards, practice, objective },
};

export default config;
